import { render, staticRenderFns } from "./MoreCardLogin.vue?vue&type=template&id=54f4bcf8&scoped=true&"
import script from "./MoreCardLogin.vue?vue&type=script&lang=js&"
export * from "./MoreCardLogin.vue?vue&type=script&lang=js&"
import style0 from "./MoreCardLogin.vue?vue&type=style&index=0&id=54f4bcf8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f4bcf8",
  null
  
)

export default component.exports